module.exports = {
  "dof-diamond-tab": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center"
  },
  "dof-diamond-tab-box": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center"
  },
  "dof-diamond-tab-item": {
    "display": "flex",
    "flexDirection": "row",
    "position": "relative"
  },
  "dof-diamond-tab-item-label": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "paddingLeft": "24",
    "paddingRight": "24",
    "borderTopWidth": "2",
    "borderBottomWidth": "2",
    "fontFamily": "PingFangSC-Regular"
  },
  "label-text": {
    "fontFamily": "PingFangSC-Regular",
    "paddingTop": "1",
    "paddingRight": "1",
    "paddingBottom": "1",
    "paddingLeft": "1"
  },
  "first-tab": {
    "borderLeftWidth": "2",
    "paddingLeft": "32"
  },
  "last-tab": {
    "borderRightWidth": "2",
    "paddingRight": "32"
  },
  "tabLine": {
    "overflow": "hidden",
    "borderTop": 0,
    "borderBottom": 0,
    "position": "relative"
  },
  "tabLineMaskDown": {
    "position": "absolute",
    "right": 0,
    "top": 0,
    "transform": "rotateZ(-77deg)",
    "transformOrigin": "right top"
  },
  "tabLineMaskUp": {
    "position": "absolute",
    "right": 0,
    "top": 0,
    "transform": "rotateZ(13deg)",
    "transformOrigin": "right top"
  },
  "border-top": {
    "borderTopWidth": "4",
    "top": "-2",
    "left": "-3",
    "right": "-3",
    "position": "absolute"
  },
  "border-bottom": {
    "height": "4",
    "bottom": "-2",
    "position": "absolute",
    "left": "-3",
    "right": "-3"
  },
  "slash": {
    "position": "absolute",
    "top": "0",
    "bottom": "0",
    "transformOrigin": "center center"
  },
  "flex-1": {
    "flex": 1
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-aeb2a70e!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-diamond-tab/index.vue
// module id = 535
// module chunks = 0 1